<template>
  <div class="upload" document.domain=''>
    <Header :hasBack="goback">
      <template slot="right">
        <a :href="downLoadUrl" :download="downloadName">
          <i
            class="el-icon-download"
            style="font-size: 24px; cursor: pointer"
            title="download out"
          ></i
        ></a>
      </template>
    </Header>
          <!-- name="loadiframe"
          id="iframe" -->
    <div class="upload-scroll">
      <div class="upload-body">
        <iframe
          id="iframeContain"
          ref="iframeContain1"
          name="iframeContain"
          :src="pathUrl"
          frameborder="0"
          width="100%"
          height="100%"
          @load="iframeLoad"
          @error="onIframeError"
        ></iframe>
      </div>
      <Footer style="width: 1170px; margin: auto" />
    </div>
    <!-- <img :src="imgSrc" alt="" style="width: 100px; height: 100px" /> -->
<!--     <button @click="downloadImg">download</button>
 -->  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import html2canvas from 'html2canvas'

export default {
  name: 'detail_dist',
  components: { Footer, Header },
  data () {
    return {
      userID: '',
      procID: '',
      pathUrl: '',
      goback: false,
      imgSrc: '',
      downLoadUrl: '',
      outTime: 5000,
      downloadName: ''
    }
  },
  created () {
  },
  mounted () {
    let params = JSON.parse(decodeURIComponent(this.$route.query.key))
    console.log('this.$route.query.key: ', this.$route.query.key)
    this.userID = params.userid
    let procid = params.procid
    let name = params.name
    // let goback = params.goback
    console.log('this.userID: ', this.userID)
    console.log('procid: ', procid)
    console.log('name: ', name)

    this.getData(procid, name)
    this.downLoadUrl = this.globalUrl + '/downloaddistfile?userID=' + this.userID + '&procID=' + procid + '&name=' + name
    console.log('downLoadUrl:', this.downLoadUrl)
  },
  methods: {
    getData (procID, name) {
      this.procID = procID
      this.pathUrl = this.globalUrl + '/outdist?userID=' + this.userID + '&procID=' + procID + '&name=' + name
      console.log('this.pathUrl:', this.pathUrl)
    },
    // #region *******************生成图片******************************** *//

    async createPic1 () {
      let imageDom = document.getElementById('iframeContain') // this.$refs.imageDom
      var rect = imageDom.getBoundingClientRect() // 获取元素相对于视口的
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop// 获取滚动轴滚动的长度
      let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
      let canvas = await html2canvas(imageDom, {
        x: rect.left, // 绘制的dom元素相对于视口的位置
        y: rect.top,
        logging: true, // 日志开关，便于查看html2canvas的内部执行流程
        width: imageDom.offsetWidth, // dom 原始宽度
        height: imageDom.offsetHeight,
        scrollX: scrollLeft, // 滚动的长度
        scrollY: -scrollTop,
        backgroundColor: 'transparent',
        allowTaint: true,
        useCORS: true
      })
      let acupointImgUrl = canvas.toDataURL('image/png')
      // this.acupointImgUrl = acupointImgUrl
      // return
      // this.uploadImg(acupointImgUrl, 'xwpf'+acupointItem.peId+'.png', acupointItem.peId)

      // // 转成图片，生成图片地址
      this.fileDownload(acupointImgUrl, '1111')
    },
    async createPic () {
      const iframeHtml = this.$refs.iframeContain1.contentWindow // 获取iframe内容
      const iframeBody = iframeHtml.document.getElementsByTagName('body')[0]
      const iframCanvas = iframeBody.getElementsByTagName('pre')[0]
      let that = this
      html2canvas(iframCanvas).then(canvas => {
        // 转成图片，生成图片地址
        canvas.toBlob(blob => {
          that.uploadImgNetwork(blob)
        }, 'image/png')
      })
    },
    // 下载图片
    fileDownload (downloadUrl, name) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = `详情图${name}.png`
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    // iframeload成功后生成图片
    iframeLoad () {
      console.log('iframeLoadiframeLoadiframeLoad')
      console.log(this.pathUrl)
      if (!this.pathUrl) {
        return
      }
      setTimeout(() => {
        this.createPic()
      }, 2500)
    },
    async uploadImgNetwork (blob) {
      try {
        const formData = new FormData()
        formData.append('file', blob, 'screenshot.png')
        formData.append('procID', this.procID)
        formData.append('name', 'screenshot.png')
        const res = await this.axios.post('/kssd/uploadImg', formData, {
          headers: {
            'UserID': this.userID,
            'Content-Type': 'multipart/form-data'
          }
        })
        console.log('图片上传结果')
        console.log(res)
        if (res.data.retCode < 0) {
          this.$message({
            showClose: true,
            message: 'Snapshot upload failed!',
            type: 'error'
          })
        } else {
          this.$message({
            showClose: true,
            message: 'Snapshot has been uploaded!',
            type: 'success'
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    onIframeError (err) {
      console.error('Failed to load iframe')
      console.log(err)
    }

  }
  // #endregion *******************生成图片******************************** *//

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.upload-scroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.upload-body {
  flex: 1;
  max-width: 1170px;
  margin: auto;
  width: 100%;
  min-height: 1px;
  text-align: left;
  min-height: 100px;
}

.iframe-pic {
  widows: 60vw;
  height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/components/detail_dist.vue